import React from 'react'

const About = () => {
    

    return (
        <div>
            <section class="text-gray-600 body-font">
                <div class="container mx-auto flex px-5 py-24 md:flex-row flex-col items-center">
                    <div class="lg:max-w-lg lg:w-full md:w-1/2 w-5/6 mb-10 md:mb-0">
                        <img class="object-cover object-center rounded" alt="hero" src="https://hips.hearstapps.com/hmg-prod/images/mh-trainer-2-1533576998.png" />
                    </div>
                    <div class="lg:flex-grow md:w-1/2 lg:pl-24 md:pl-16 flex flex-col md:items-start md:text-left items-center text-center">
                        <h1 class="title-font sm:text-4xl text-3xl mb-4 font-medium text-gray-900">Work One-on-One with a Fitness Coach
                        </h1>
                        <p class="mb-8 leading-relaxed">
                        Train on your own or get personalized guidance from a certified fitness coach. Receive expert feedback, tailored workout routines, and motivational support. Dive deep into specific exercises to master form and technique. Get guidance on balancing strength training, flexibility, and cardio. Receive expert nutrition advice to complement your workouts. Whether you're aiming for weight loss, muscle gain, or improving athletic performance, your coach will craft a plan designed just for you. Track your progress and achieve your fitness goals faster with customized strategies and accountability.
                        </p>
                        <div class="flex justify-center">
                            <button class="inline-flex text-white bg-[#00925D] border-0 py-2 px-6 focus:outline-none hover:bg-[#00925D] rounded text-lg">Enroll Now</button>
                            <button class="ml-4 inline-flex text-gray-700 bg-gray-100 border-0 py-2 px-6 focus:outline-none hover:bg-gray-200 rounded text-lg">Pricing</button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default About